import { Link } from 'react-router-dom';
import type { ApiReconstructedDocumentDetail } from '@avisoma/shared';

export function SourceDocumentsCard({ entity }: { entity: ApiReconstructedDocumentDetail }) {
  const docs = entity.sourceDocuments;
  if (docs.length === 0) return null;

  return (
    <div className="bg-white dark:bg-zinc-800 dark:border dark:border-zinc-700 shadow sm:rounded-lg p-4 sm:p-5">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-medium text-gray-700 dark:text-zinc-200">Source documents</h2>
        {docs.length > 1 && (
          <span className="text-xs text-gray-500 dark:text-zinc-500">
            This entity is content-keyed and surfaces in {docs.length} uploads
          </span>
        )}
      </div>

      <div className="mt-3 flex flex-col gap-1.5">
        {docs.map((d) => (
          <Link
            key={d.documentId}
            to={`/documents/${d.documentId}`}
            className="flex items-center justify-between gap-3 px-3 py-2 rounded-md bg-gray-50 dark:bg-zinc-900 hover:bg-gray-100 dark:hover:bg-zinc-800 text-sm"
          >
            <span className="truncate text-blue-600 dark:text-blue-400" title={d.fileName}>
              {d.fileName}
            </span>
            <span className="shrink-0 text-xs text-gray-500 dark:text-zinc-500">
              pages {d.startPageIndex + 1} – {d.endPageIndex + 1}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
